import {FormInput} from "../../@types/pricingFormInputsResources.ts";
import {RegexPatternEnum} from "../../enum/pattern/regexPatternEnum.ts";

export const PricingFormInputsConfig: FormInput[] = [
    {
        firstClass: 'form-column row md-4',
        secondClass: 'form-column col-md-6 mb-4',
        label: 'payments_per_month',
        required: true,
        isSelect: true,
        selectOptions: [
            {name: '0-50'},
            {name: '51-200'},
            {name: '201-500'},
            {name: '501-1000'},
            {name: '1001-5000'},
            {name: '5001-10000'},
            {name: '10000+'}
        ],
        secondInput: {
            firstClass: 'form-column row md-4',
            secondClass: 'form-column col-md-6 mb-4',
            label: 'average_basket',
            required: true,
            isSelect: true,
            selectOptions: [
                {name: '< 10 €'},
                {name: '11-30 €'},
                {name: '31-50 €'},
                {name: '51-100 €'},
                {name: '101-200 €'},
                {name: '201-1000 €'},
                {name: '1000+ €'},
            ]
        }
    },
    {
        firstClass: 'form-column row',
        secondClass: 'form-column col-12 mb-4',
        label: 'website_address',
        required: true,
        type: 'text',
        placeholder: 'https://www.example.com',
    },
    {
        firstClass: 'form-column row md-4',
        secondClass: 'form-column col-md-6 mb-4',
        label: 'website_content_management_system',
        required: true,
        isSelect: true,
        selectOptions: [
            {name: 'Shopify'},
            {name: 'WordPress- WooCommerce'},
            {name: 'Prestashop'},
            {name: 'OpenCart'},
            {name: 'Magento'},
            {name: 'Joomla- VirtueMart'},
            {name: 'Eshoprent'},
            {name: 'Verskis'},
            {name: 'Hostpartner'},
            {name: 'LeShopo'},
            {name: 'api_integration'},
            {name: 'other'},
        ],
        secondInput: {
            firstClass: 'form-column row md-4',
            secondClass: 'form-column col-md-6 mb-4',
            label: 'phone_number',
            required: true,
            type: 'tel',
            maxLength: 16,
            pattern: '^[0-9\\-\\+\\s\\(\\)]*$',
            placeholder: '+370 611 55554',
        }
    },
    {
        firstClass: 'form-column row',
        secondClass: 'form-column col-12 mb-4',
        label: 'email',
        required: true,
        type: 'email',
        pattern: RegexPatternEnum.email,
    },
    {
        firstClass: 'form-column row',
        secondClass: 'form-column col-12 mb-4',
        label: 'special_code',
        required: false,
        type: 'text',
        placeholder: 'type_here',
    },
]

export const ConferenceFormInputsConfig: FormInput[] = [
    {
        firstClass: 'form-column row',
        secondClass: 'form-column col-12 mb-4',
        label: 'website_address',
        required: true,
        type: 'text',
        placeholder: 'https://www.example.com',
    },
    {
        firstClass: 'form-column row md-4',
        secondClass: 'form-column col-md-6 mb-4',
        label: 'payments_per_month',
        required: true,
        type: 'number',
        secondInput: {
            firstClass: 'form-column row md-4',
            secondClass: 'form-column col-md-6 mb-4',
            label: 'phone_number',
            required: true,
            type: 'tel',
            maxLength: 16,
            pattern: '^[0-9\\-\\+\\s\\(\\)]*$',
            placeholder: '+370 611 55554',
        }
    },
    {
        firstClass: 'form-column row',
        secondClass: 'form-column col-12 mb-4',
        label: 'email',
        required: true,
        type: 'email',
        pattern: RegexPatternEnum.email,
    }
]
